/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { MdClose, MdSearch } from 'react-icons/md';
import { isMobileWidth } from '../../../shared/helper-utils/appUtils';
import AppHidden from '../../../shared/components/app-hidden/AppHidden';

function HotelFilters({
  minPrice,
  maxPrice,
  selectedFilters,
  onApplyFilter,
  amenitiesList,
  onClearFilters,
  onCloseMobile,
  currencyOption,
  conversionRate,
  hotelNames,
  hotelLocations,
  starCount,
  facilities,
  propertyTypes,
}) {
  const intl = useIntl();

  const [selectedMinPrice, setSelectedMinPrice] = useState(
    selectedFilters.selectedMinPrice !== undefined
      ? selectedFilters.selectedMinPrice
      : minPrice,
  );
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(
    selectedFilters.selectedMaxPrice !== undefined
      ? selectedFilters.selectedMaxPrice
      : maxPrice,
  );
  const [minInput, setMinInput] = useState(
    selectedFilters.selectedMinPrice !== undefined &&
      selectedFilters.selectedMinPrice !== minPrice
      ? selectedFilters.selectedMinPrice.toString()
      : '',
  );
  const [maxInput, setMaxInput] = useState(
    selectedFilters.selectedMaxPrice !== undefined &&
      selectedFilters.selectedMaxPrice !== maxPrice
      ? selectedFilters.selectedMaxPrice.toString()
      : '',
  );
  const [selectedRating, setSelectedRating] = useState(
    selectedFilters.selectedRating || [],
  );
  const [selectedFacilities, setSelectedFacilities] = useState(
    selectedFilters.selectedFacilities,
  );
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState(
    selectedFilters.selectedPropertyTypes,
  );
  const [selectedLocation, setSelectedLocation] = useState(
    selectedFilters.hotelAddress || '',
  );

  // Hotel name search
  const [hotelNameInput, setHotelNameInput] = useState(
    selectedFilters.hotelName || '',
  );
  const [showNameSuggestions, setShowNameSuggestions] = useState(false);
  const nameInputRef = useRef(null);

  // Location search
  const [locationInput, setLocationInput] = useState('');
  const [showLocationSuggestions, setShowLocationSuggestions] = useState(false);
  const locationInputRef = useRef(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
    setMinInput('');
    setMaxInput('');
  }, [minPrice, maxPrice]);

  useEffect(() => {
    setSelectedRating(selectedFilters.selectedRating);
  }, [selectedFilters.selectedRating]);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (nameInputRef.current && !nameInputRef.current.contains(e.target)) {
        setShowNameSuggestions(false);
      }
      if (
        locationInputRef.current &&
        !locationInputRef.current.contains(e.target)
      ) {
        setShowLocationSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const buildPayload = (overrides = {}) => ({
    selectedMinPrice,
    selectedMaxPrice,
    hotelName: hotelNameInput,
    hotelAddress: selectedLocation,
    selectedRating,
    selectedFacilities,
    selectedPropertyTypes,
    ...overrides,
  });

  // ── Hotel name handlers ──────────────────────────────────────────────────────

  const filteredHotelNames = hotelNames.filter(
    (h) =>
      hotelNameInput.trim() &&
      h.label.toLowerCase().includes(hotelNameInput.toLowerCase()),
  );

  const handleHotelNameSelect = (name) => {
    setHotelNameInput(name);
    setShowNameSuggestions(false);
    onApplyFilter(buildPayload({ hotelName: name }));
  };

  const handleHotelNameChange = (val) => {
    setHotelNameInput(val);
    setShowNameSuggestions(true);
    // onApplyFilter(buildPayload({ hotelName: val }));
  };

  const handleClearHotelName = () => {
    setHotelNameInput('');
    setShowNameSuggestions(false);
    onApplyFilter(buildPayload({ hotelName: '' }));
  };

  // ── Location handlers ────────────────────────────────────────────────────────

  const filteredLocations = hotelLocations.filter(
    (l) =>
      !locationInput.trim() ||
      l.label.toLowerCase().includes(locationInput.toLowerCase()),
  );

  const handleLocationSelect = (locValue, locLabel) => {
    const newLoc = selectedLocation === locValue ? '' : locValue;
    setSelectedLocation(newLoc);
    setLocationInput(newLoc ? locLabel : '');
    setShowLocationSuggestions(false);
    onApplyFilter(buildPayload({ hotelAddress: newLoc }));
  };

  const handleLocationInputChange = (val) => {
    setLocationInput(val);
    setSelectedLocation('');
    setShowLocationSuggestions(true);
    // onApplyFilter(buildPayload({ hotelAddress: val }));
  };

  const handleClearLocation = () => {
    setLocationInput('');
    setSelectedLocation('');
    setShowLocationSuggestions(false);
    onApplyFilter(buildPayload({ hotelAddress: '' }));
  };

  // ── Chip / checkbox handlers ─────────────────────────────────────────────────

  const handleChipSelection = (name, value) => {
    let list = [];
    if (name === 'rating') list = [...selectedRating];
    else if (name === 'facilities') list = [...selectedFacilities];
    else if (name === 'propertyTypes') list = [...selectedPropertyTypes];

    const idx = list.indexOf(value);
    if (idx > -1) list.splice(idx, 1);
    else list.push(value);

    if (name === 'rating') {
      setSelectedRating(list);
      onApplyFilter(buildPayload({ selectedRating: list }));
    } else if (name === 'facilities') {
      setSelectedFacilities(list);
      onApplyFilter(buildPayload({ selectedFacilities: list }));
    } else if (name === 'propertyTypes') {
      setSelectedPropertyTypes(list);
      onApplyFilter(buildPayload({ selectedPropertyTypes: list }));
    }
  };

  const handlePriceInput = (field, value) => {
    let newMin = selectedMinPrice;
    let newMax = selectedMaxPrice;

    if (field === 'min') {
      setMinInput(value);
      newMin = value !== '' ? Number(value) : minPrice;
    } else {
      setMaxInput(value);
      newMax = value !== '' ? Number(value) : maxPrice;
    }

    setSelectedMinPrice(newMin);
    setSelectedMaxPrice(newMax);
    onApplyFilter(
      buildPayload({ selectedMinPrice: newMin, selectedMaxPrice: newMax }),
    );
  };

  const handleClearFilters = () => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
    setMinInput('');
    setMaxInput('');
    setSelectedRating([]);
    setSelectedFacilities([]);
    setSelectedPropertyTypes([]);
    setSelectedLocation('');
    setHotelNameInput('');
    setLocationInput('');
    onClearFilters();
  };

  const handleApplyMobileFilter = () => {
    onApplyFilter({
      selectedMinPrice,
      selectedMaxPrice,
      hotelName: hotelNameInput,
      hotelAddress: selectedLocation,
      selectedRating,
      selectedFacilities,
      selectedPropertyTypes,
    });
    if (onCloseMobile) onCloseMobile();
  };

  const minLabel = minInput !== '' ? `₹${minInput}` : 'Min';
  const maxLabel = maxInput !== '' ? `₹${maxInput}` : 'Max';

  return (
    <div className="hotel-filters-panel">
      {/* Header */}
      <AppHidden smDown>
        <div className="hotel-filters-panel__header">
          <h3 className="hotel-filters-panel__title">Filters</h3>
          <button
            type="button"
            className="hotel-filters-panel__clear-all"
            onClick={handleClearFilters}
          >
            Clear All
          </button>
        </div>
      </AppHidden>

      {/* 1. Property Name Search */}
      <div className="hotel-filters-panel__section">
        <h4 className="hotel-filters-panel__section-title">Property Name</h4>
        <div className="hf-search-box" ref={nameInputRef}>
          <div className="hf-search-box__input-wrap">
            <MdSearch className="hf-search-box__icon" />
            <input
              className="hf-search-box__input"
              placeholder="Search by hotel name…"
              value={hotelNameInput}
              onChange={(e) => handleHotelNameChange(e.target.value)}
              onFocus={() => setShowNameSuggestions(true)}
            />
            {hotelNameInput && (
              <button
                type="button"
                className="hf-search-box__clear"
                onClick={handleClearHotelName}
              >
                <MdClose />
              </button>
            )}
          </div>
          {showNameSuggestions && filteredHotelNames.length > 0 && (
            <ul className="hf-search-box__suggestions">
              {filteredHotelNames.map((h) => (
                <li
                  key={h.value}
                  className={`hf-search-box__suggestion${
                    hotelNameInput === h.label
                      ? ' hf-search-box__suggestion--active'
                      : ''
                  }`}
                  onMouseDown={() => handleHotelNameSelect(h.value)}
                >
                  {h.label}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* 2. Pricing Range */}
      <div className="hotel-filters-panel__section">
        <h4 className="hotel-filters-panel__section-title">Pricing Range</h4>
        <div className="hotel-filters-panel__price-row">
          <div className="hotel-filters-panel__price-input-wrap">
            <span className="hotel-filters-panel__price-label">
              Minimum Price
            </span>
            <input
              type="number"
              placeholder="Enter Minimum Price"
              value={minInput}
              onChange={(e) => handlePriceInput('min', e.target.value)}
              className="hotel-filters-panel__price-input"
            />
          </div>
          <div className="hotel-filters-panel__price-input-wrap">
            <span className="hotel-filters-panel__price-label">
              Maximum Price
            </span>
            <input
              type="number"
              placeholder="Enter Maximum Price"
              value={maxInput}
              onChange={(e) => handlePriceInput('max', e.target.value)}
              className="hotel-filters-panel__price-input"
            />
          </div>
        </div>
        <div className="hotel-filters-panel__selected-range">
          Selected Range:&nbsp;{minLabel}&nbsp;-&nbsp;{maxLabel}
        </div>
      </div>

      {/* 3. Star Rating */}
      <div className="hotel-filters-panel__section">
        <h4 className="hotel-filters-panel__section-title">Star Rating</h4>
        <div className="hotel-filters-panel__checks">
          {[1, 2, 3, 4, 5].map((star) => (
            <label key={star} className="hotel-filters-panel__check-item">
              <input
                type="checkbox"
                checked={selectedRating.includes(star.toString())}
                onChange={() => handleChipSelection('rating', star.toString())}
              />
              <span>
                {star} Star{star > 1 ? 's' : ''}
              </span>
              {starCount && (
                <span className="hotel-filters-panel__check-count">
                  {starCount[star] || 0}
                </span>
              )}
            </label>
          ))}
        </div>
      </div>

      {/* 4. Property Type */}
      {propertyTypes.length > 0 && (
        <div className="hotel-filters-panel__section">
          <h4 className="hotel-filters-panel__section-title">Property Type</h4>
          <div className="hotel-filters-panel__chips">
            {propertyTypes.map((property) => (
              <button
                type="button"
                key={property}
                className={`hotel-filters-panel__chip${
                  selectedPropertyTypes.includes(property)
                    ? ' hotel-filters-panel__chip--active'
                    : ''
                }`}
                onClick={() => handleChipSelection('propertyTypes', property)}
              >
                {property}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* 6. Location Search */}
      {hotelLocations.length > 0 && (
        <div className="hotel-filters-panel__section">
          <h4 className="hotel-filters-panel__section-title">Location</h4>
          <div className="hf-search-box" ref={locationInputRef}>
            <div className="hf-search-box__input-wrap">
              <MdSearch className="hf-search-box__icon" />
              <input
                className="hf-search-box__input"
                placeholder="Search by location…"
                value={
                  locationInput ||
                  (selectedLocation
                    ? hotelLocations.find((l) => l.value === selectedLocation)
                        ?.label || selectedLocation
                    : '')
                }
                onChange={(e) => handleLocationInputChange(e.target.value)}
                onFocus={() => setShowLocationSuggestions(true)}
              />
              {(locationInput || selectedLocation) && (
                <button
                  type="button"
                  className="hf-search-box__clear"
                  onClick={handleClearLocation}
                >
                  <MdClose />
                </button>
              )}
            </div>
            {showLocationSuggestions && filteredLocations.length > 0 && (
              <ul className="hf-search-box__suggestions">
                {filteredLocations.slice(0, 8).map((loc) => (
                  <li
                    key={loc.value}
                    className={`hf-search-box__suggestion${
                      selectedLocation === loc.value
                        ? ' hf-search-box__suggestion--active'
                        : ''
                    }`}
                    onMouseDown={() =>
                      handleLocationSelect(loc.value, loc.label)
                    }
                  >
                    {loc.label}
                  </li>
                ))}
              </ul>
            )}
          </div>
          {/* Selected location chip */}
          {selectedLocation && (
            <div className="hf-selected-chip mt-2">
              <span>
                {hotelLocations.find((l) => l.value === selectedLocation)
                  ?.label || selectedLocation}
              </span>
              <button type="button" onClick={handleClearLocation}>
                <MdClose />
              </button>
            </div>
          )}
        </div>
      )}

      {/* 5. Amenities */}
      {facilities.length > 0 && (
        <div className="hotel-filters-panel__section">
          <h4 className="hotel-filters-panel__section-title">Amenities</h4>
          <div className="hotel-filters-panel__checks">
            {facilities.slice(0, 6).map((facility) => (
              <label key={facility} className="hotel-filters-panel__check-item">
                <input
                  type="checkbox"
                  checked={selectedFacilities.includes(facility)}
                  onChange={() => handleChipSelection('facilities', facility)}
                />
                <span>{facility}</span>
              </label>
            ))}
          </div>
        </div>
      )}

      {/* Mobile action buttons */}
      <AppHidden xsOnly>
        <div className="hotel-filters-panel__mobile-actions">
          <button
            type="button"
            className="hotel-filters-panel__apply-btn"
            onClick={handleApplyMobileFilter}
          >
            Apply Filters
          </button>
          <button
            type="button"
            className="hotel-filters-panel__reset-btn"
            onClick={handleClearFilters}
          >
            Reset
          </button>
        </div>
      </AppHidden>
    </div>
  );
}

HotelFilters.propTypes = {
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  amenitiesList: PropTypes.array.isRequired,
  onClearFilters: PropTypes.func.isRequired,
  onCloseMobile: PropTypes.func,
  currencyOption: PropTypes.any.isRequired,
  conversionRate: PropTypes.any.isRequired,
  hotelLocations: PropTypes.array.isRequired,
  hotelNames: PropTypes.array.isRequired,
  starCount: PropTypes.any.isRequired,
  facilities: PropTypes.array.isRequired,
  propertyTypes: PropTypes.array.isRequired,
};

export default HotelFilters;
